<template>
    <Form
        :provider="sepaProvider"
        :sepa-providers="sepaProviders"
        :sepa-settings="sepaSettings"
        :windata-settings="windataSettings"
        :cobase-settings="cobaseSettings"
        :errors="errors"
        @form-submitted="submitData"
    />
</template>

<script setup>
import Form from '~@/Components/Settings/SepaSettings/Form'
import { route } from '~@/Composables/route'

defineProps({
    sepaSettings: {
        type: Object,
        default: () => {
            return {}
        }
    },
    windataSettings: {
        type: Object,
        default: () => {
            return {}
        }
    },
    cobaseSettings: {
        type: Object,
        default: () => {
            return {}
        }
    },
    sepaProvider: {
        type: String,
        default: 'windata'
    },
    sepaProviders: {
        type: Array,
        default: () => {
            return []
        }
    },
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const submitData = (form) => {
    form.post(route('settings.sepa-settings.store'))
}
</script>
